<template>
  <div class="ic-assistant" :class="{'web':!isMobile}">
    <div class="header">
      <van-image width="4rem" height="0.76rem" :src="ypLogo" />
      <span class="name">名企挑战营现场赛</span>
      <p v-if="status !== 'login'" class="logined-person" @click="handleShowLogoutDialog">评委:<span style="margin-left: 6px">{{ loginForm.name }}</span></p>
    </div>
    <!-- 口令页 -->
    <div v-if="status === 'login'" class="login-page">
      <h3 class="login-head">请输入用户名和口令</h3>
      <van-field v-model="loginForm.name" label="用户名" size="large" autofocus colon placeholder="请输入用户名" :clearable="isMobile" />
      <van-field v-model="loginForm.code" label="口令" size="large" colon :maxlength="8" placeholder="请输入8位数字口令" :clearable="isMobile" />
      <div style="margin: 1rem 0.3rem 0.3rem;">
        <van-button block type="primary" :disabled="loginForm.name.length === 0 || loginForm.code.length === 0" @click="login">登录</van-button>
      </div>
    </div>
    <!-- first 评选页 -->
    <div v-if="status === 'first'" class="rate-page">
      <van-divider>参赛选手</van-divider>
      <div class="page">
        <div class="page-right" style="width: 100%; flex-wrap:wrap; justify-content:space-evenly">
          <van-empty v-if="cAMLeadList < 1" description="暂无数据" style="margin:auto" />
          <van-card v-for="(item,index) in cAMLeadList" :key="index" :style="{width:'360px'}" :thumb="item.profilePhotoUrl || defaultAvatar" :tag="item.isSpecial?'★': ''" :class="{'not-top20': !item.isTop20}" :title="item.leadName" :desc="item.school">
            <template #tags>
              <van-tag v-if="item.major" plain size="medium" color="#999" text-color="#999">{{ item.major }}</van-tag>
              <van-tag v-if="item.grade" plain size="medium" color="#999" text-color="#999">{{ item.grade }}</van-tag>
            </template>
            <template #footer>
              <div class="rate-box" style="height: 26px">
                <span v-if="item.fullUrl && item.fullUrl.length > 0" class="resumes">
                  <a v-for="(i,idx) in item.fullUrl" :key="idx" class="link" :href="i" target="_blank">简历{{ idx + 1 }}</a>
                </span>
              </div>
              <div class="rate-box score">
                <span class="rate-label" style="font-weight: bold">Q1~Q3 score:<span style="color:#d04a02;margin-left:2px;">{{ item.qScore }}分</span></span>
              </div>
              <div v-if="item.dimensions" class="rate-box score"><span class="rate-label">Critical Thinking:</span>
                <van-rate v-model="item.dimensions[0].score" allow-half :count="3" size="0.42rem" color="var(--primary-color)" :readonly="isReadOnly" :disabled="isSubmit" @change="modify(item, 'q1')" />
                <span style="color:#d04a02;margin-left:2px;">{{ item.dimensions[0].score }}分</span>
              </div>
              <div v-if="item.dimensions" class="rate-box score"><span class="rate-label">Primary data analysis skills:</span>
                <van-rate v-model="item.dimensions[1].score" allow-half :count="3" size="0.4rem" color="var(--primary-color)" :readonly="isReadOnly" :disabled="isSubmit" @change="modify(item, 'q2')" />
                <span style="color:#d04a02;margin-left:2px;">{{ item.dimensions[1].score }}分</span>
              </div>
              <div v-if="item.dimensions" class="rate-box score"><span class="rate-label">Business Acumen:</span>
                <van-rate v-model="item.dimensions[2].score" allow-half :count="3" size="0.42rem" color="var(--primary-color)" :readonly="isReadOnly" :disabled="isSubmit" @change="modify(item, 'q3')" />
                <span style="color:#d04a02;margin-left:2px;">{{ item.dimensions[2].score }}分</span>
              </div>
              <div v-if="item.dimensions" class="rate-box score"><span class="rate-label">Presentation Skills:</span>
                <van-rate v-model="item.dimensions[3].score" allow-half :count="3" size="0.42rem" color="var(--primary-color)" :readonly="isReadOnly" :disabled="isSubmit" @change="modify(item, 'q4')" />
                <span style="color:#d04a02;margin-left:2px;">{{ item.dimensions[3].score }}分</span>
              </div>
              <div v-if="item.dimensions" class="rate-box score"><span class="rate-label">Q5 Overall Rating:<span style="color:#d04a02;margin-left:2px;">{{ ((item.dimensions.reduce((acc, cur) => acc + cur.score, 0)) / 4).toFixed(2) }}分</span></span>
              </div>
              <div class="rate-box comments">
                <!-- <van-field v-model="item.comments" rows="3" autosize type="textarea" placeholder="您对同学的反馈" @input="debounceModify(item)" /> -->
              </div>
            </template>
          </van-card>
          <!-- <div class="bottom">
            <van-button block type="primary" :disabled="isSubmit" @click="checkAllScored">{{ '提交' }}</van-button>
          </div> -->
        </div>
      </div>
    </div>
    <!-- second 评选页 -->
    <div v-if="status === 'second'" class="rate-page">
      <van-divider>晋级选手</van-divider>
      <div class="page">
        <div v-if="leadList.length > 0" style="margin-bottom:16px">
          <van-tabs v-model="activePMGroup">
            <van-tab v-for="(item, index) in cPMGroup" :key="item.text" :title="item.text" :name="index" />
          </van-tabs>
        </div>
        <div class="page-right">
          <van-empty v-if="cPMLeadList.length < 1" description="暂无数据" />
          <van-card v-for="(item,index) in cPMLeadList" :key="index" :style="getPMCardStyle(index)" :thumb="item.profilePhotoUrl || defaultAvatar" :tag="item.isSpecial?'★': ''" :class="{'not-top20': !item.isTop20}" :title="item.leadName" :desc="item.school">
            <template #tags>
              <van-tag v-if="item.major" plain size="medium" color="#999" text-color="#999">{{ item.major }}</van-tag>
              <van-tag v-if="item.grade" plain size="medium" color="#999" text-color="#999">{{ item.grade }}</van-tag>
            </template>
            <template #footer>
              <div class="morning">
                <div class="rate-box" style="height: 26px">
                  <span v-if="item.fullUrl && item.fullUrl.length > 0" class="rate-box resumes">
                    <a v-for="(i,idx) in item.fullUrl" :key="idx" class="link" :href="i" target="_blank">简历{{ idx + 1 }}</a>
                  </span>
                </div>
                <p class="text history" style="display:none">上午场测评总分(10分):
                  <span class="text-primary">{{ item.amTotalScore }}分</span>
                </p>
                <p class="text history" style="display:none">上午场测评评委评分(3分):
                  <span class="text-primary">{{ item.dimensionScore }}分</span>
                </p>
              </div>
              <div class="rate-box group-radio"><span class="rate-label">实习建议:</span>
                <van-radio-group v-model="item.recommendation" direction="horizontal" icon-size="0.42rem" style="margin-top: 0.1rem;" @change="modify(item)" :disabled="isReadOnly">
                  <van-radio name="1"><span :class="{'text-primary':item.recommendation==='1'}">Yes</span></van-radio>
                  <van-radio name="2">Marginal</van-radio>
                  <van-radio name="3">No</van-radio>
                </van-radio-group>
              </div>
              <div v-if="item.dimensions" class="rate-box score"><span class="rate-label">沟通能力/商业演讲:</span>
                <van-rate v-model="item.dimensions[0].score" allow-half :count="5" size="0.42rem" color="var(--primary-color)" :readonly="isReadOnly" :disabled="isSubmit" @change="modify(item, 'q1')" />
                <span style="color:#d04a02;margin-left:2px;">{{ item.dimensions[0].score * 2 }}分</span>
              </div>
              <div v-if="item.dimensions" class="rate-box score"><span class="rate-label">商业思维:</span>
                <van-rate v-model="item.dimensions[1].score" allow-half :count="5" size="0.4rem" color="var(--primary-color)" :readonly="isReadOnly" :disabled="isSubmit" @change="modify(item, 'q2')" />
                <span style="color:#d04a02;margin-left:2px;">{{ item.dimensions[1].score * 2 }}分</span>
              </div>
              <div v-if="item.dimensions" class="rate-box score"><span class="rate-label">领导力/团队合作:</span>
                <van-rate v-model="item.dimensions[2].score" allow-half :count="5" size="0.42rem" color="var(--primary-color)" :readonly="isReadOnly" :disabled="isSubmit" @change="modify(item, 'q3')" />
                <span style="color:#d04a02;margin-left:2px;">{{ item.dimensions[2].score * 2 }}分</span>
              </div>
              <div v-if="item.dimensions" class="rate-box score"><span class="rate-label">信息收集和分析能力:</span>
                <van-rate v-model="item.dimensions[3].score" allow-half :count="5" size="0.42rem" color="var(--primary-color)" :readonly="isReadOnly" :disabled="isSubmit" @change="modify(item, 'q4')" />
                <span style="color:#d04a02;margin-left:2px;">{{ item.dimensions[3].score * 2 }}分</span>
              </div>
              <div class="rate-box comments">
                <!-- <van-field v-model="item.comments" rows="3" autosize type="textarea" placeholder="您对同学的反馈" @input="debounceModify(item)" /> -->
              </div>
            </template>
          </van-card>
          <!-- <div v-if="!isReadOnly && leadList.length > 0" class="bottom">
            <van-button block type="primary" :disabled="isSubmit" @click="checkAllScored">{{ isSubmit? '已提交': '提交' }}</van-button>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { upload } from '@/mixin/file'
import { getIcAssistantAMStatus, getIcAssistantPMStatus, setIcAssistantAMStatus, setIcAssistantPMStatus } from '@/util/auth'
import { getAliyunOSSDownloadAuthorizationPX } from '@/api/file'

import { http } from '@/api'
import { PublicEvent } from '@/api/collection'
import defaultAvatar from '@/assets/default-avatar.jpg'
import ypLogo from '@/assets/logo.png'
import { debounce } from 'lodash'

import Detect from '@/util/detect'
const isMobile = Detect(window.navigator.userAgent).mobile()

import {
  Field,
  PasswordInput,
  NumberKeyboard,
  Card,
  Image,
  Tag,
  Rate,
  Icon,
  Toast,
  Notify,
  Button,
  Dialog,
  Checkbox,
  Divider,
  Empty,
  RadioGroup,
  Radio
} from 'vant'
export default {
  name: 'IcAssistant',
  components: {
    [Field.name]: Field,
    [PasswordInput.name]: PasswordInput,
    [NumberKeyboard.name]: NumberKeyboard,
    [Card.name]: Card,
    [Image.name]: Image,
    [Tag.name]: Tag,
    [Rate.name]: Rate,
    [Icon.name]: Icon,
    [Toast.name]: Toast,
    [Notify.name]: Notify,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [Divider.name]: Divider,
    [Empty.name]: Empty,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio
  },
  mixins: [upload],
  data() {
    return {
      ypLogo,
      isMobile,
      type: this.$route.query.type,
      status: 'login',
      loginForm: {
        name: '',
        code: ''
      },
      pattern: /\d{8}/,
      group: 'G1',
      groupList: ['G1', 'G2', 'G3', 'G4'],
      defaultAvatar,
      firstData: {
        G1: [],
        G2: [],
        G3: [],
        G4: []
      },
      leadList: [],
      isSubmit: false,
      isReadOnly: false,
      activePMGroup: 0,
      activeAMGroup: 0,
      debounceModify: () => {}
    }
  },
  computed: {
    cAMGroup() {
      return [
        { text: '第一组' },
        { text: '第二组' },
        { text: '第三组' },
        { text: '第四组' }
      ]
    },
    cPMGroup() {
      return [
        { text: 'Magic A4' },
        { text: 'VENI VIDI VICI' },
        { text: '取个名字好难' },
        { text: '大巴黎小队' },
        { text: '美来自我们' },
        { text: '凭亿近人' },
        { text: 'Gucci眼泪Pardaparada的Dior组' },
        { text: '奢华主义接班人' },
        { text: 'Cicilia Consulting Team' },
        { text: '复活组' }
      ]
    },
    cAMLeadList() {
      return this.leadList
    },
    cPMLeadList() {
      // crm 0 is ungrouped
      return this.leadList.filter(v => this.activePMGroup + 1 === Number(v.groupName))
    }
  },
  created() {
    this.debounceModify = debounce(this.modify, 500)
  },
  // 创建前设置
  beforeCreate() {
    if (!isMobile) {
      document.querySelector('html').setAttribute('style', 'font-size: 64px;')
    }
  },
  mounted() {
    let cookieObj = {}
    if (this.type === 'first') {
      cookieObj = getIcAssistantAMStatus()
    }
    if (this.type === 'second') {
      cookieObj = getIcAssistantPMStatus()
    }
    if (Object.keys(cookieObj).length !== 0) {
      this.loginForm.name = cookieObj.name
      this.loginForm.code = cookieObj.code
      this.status = cookieObj.status
      this.getLeadList()
    }
    window.onresize = debounce(() => {
      this.leadList = [...this.leadList]
    }, 500)
  },
  methods: {
    getPMCardStyle(index) {
      const container = document.querySelector('.page-right')
      if (!container) {
        return {}
      }
      const cardWidth = 360
      const cardNum = this.cPMLeadList.length
      const cardMarginRight = 6
      const containerWidth = document.querySelector('.page-right').getClientRects()[0].width

      let scale = containerWidth / ((cardWidth + cardMarginRight) * cardNum)
      let translateX = ((1 - scale) * (cardWidth + cardMarginRight)) / scale
      if (scale > 1) {
        scale = 1
        translateX = 0
      }

      return {
        transform: `scale(${scale}) translateX(-${index * translateX}px)`,
        transformOrigin: 'left top',
        width: `${cardWidth}px`,
        marginRight: `${cardMarginRight}px`,
        'flexShrink': 0
      }
    },
    async login() {
      await this.getLeadList()
    },
    async getLeadList() {
      Toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      const res = await http({
        path: PublicEvent.GetICLeads.path,
        method: PublicEvent.GetICLeads.method,
        data: { activityType: '202210', amorpm: this.getAMorPM(), ...this.loginForm }
      })
      if (res.resultCode === '0') {
        this.isReadOnly = res.isReadOnly
        if (this.getAMorPM() === 'AM') {
          setIcAssistantAMStatus({
            name: this.loginForm.name,
            code: this.loginForm.code,
            status: this.type
          })
        }
        if (this.getAMorPM() === 'PM') {
          setIcAssistantPMStatus({
            name: this.loginForm.name,
            code: this.loginForm.code,
            status: this.type
          })
        }

        this.status = this.type
        const resData = res.data
        this.leadList = resData

        resData.forEach((v, i) => {
          const dimensions = JSON.parse(v.dimensionJson || '[{"Question":"q1","score":0.0},{"Question":"q2","score":0.0},{"Question":"q3","score":0.0},{"Question":"q4","score":0.0}]')
          if (this.getAMorPM() === 'PM') {
            dimensions.forEach(v => {
              v.score = v.score / 2
            })
          }
          this.$set(this.leadList[i], 'dimensions', dimensions)
        })

        // 获取全路径简历
        for (let index = 0; index < resData.length; index++) {
          const urlArr = []
          if (resData[index].cvUrl && resData[index].cvUrl.length > 0) {
            for (let i = 0; i < resData[index].cvUrl.length; i++) {
              const url = await getAliyunOSSDownloadAuthorizationPX(resData[index].cvUrl[i])
              urlArr.push(url)
            }
          }
          this.$set(this.leadList[index], 'fullUrl', urlArr.slice(0, 2))
        }

        Toast.clear()
      } else {
        Notify({ type: 'danger', message: res.resultMsg, duration: 3 * 1000 })
      }
    },
    async modify(item, question) {
      const data = {
        leadId: item.leadId,
        aMorPM: this.getAMorPM(),
        ...this.loginForm,
        dimensions: item.dimensions,
        comments: item.comments,
        recommendation: item.recommendation
      }
      if (this.getAMorPM() === 'PM') {
        data.dimensions = data.dimensions.map(v => {
          const score = v.score * 2
          // if (v.Question === question) {
          //   score = score * 2
          // }
          return { ...v, score }
        })
      }

      const res = await http({
        path: PublicEvent.SaveICAMorPMScore.path,
        method: PublicEvent.SaveICAMorPMScore.method,
        data
      })
      if (res.resultCode === '0') {
        console.log(res.resultMsg)
      }
    },
    checkAllScored() {
      // check all leads whether scored
      Dialog.confirm({
        title: '提交评分',
        message: '评分提交后将不得修改，请确认是否提交'
      })
        .then(async() => {
          this.submit()
        })
        .catch(() => {
          console.log('Cancel submit')
        })
    },
    getAMorPM() {
      if (this.type === 'first') {
        return 'AM'
      }
      if (this.type === 'second') {
        return 'PM'
      }
    },
    handleShowLogoutDialog() {
      Dialog.confirm({
        message: '退出当前登录'
      }).then(() => {
        if (this.getAMorPM() === 'AM') {
          setIcAssistantAMStatus({
          })
        }
        if (this.getAMorPM() === 'PM') {
          setIcAssistantPMStatus({
          })
        }
        location.reload()
      }).catch(() => {
        console.info('cancel logout')
      })
    }
  }
}
</script>
<style lang="scss">
:root {
  --primary-color: #d04a02;
  --tangerine-color: #eb8c00;
  --yellow-color: #ffb600;
}

.ic-assistant.web {
	margin: 0 auto;
	.rate-page {
    .page {
      width: 100%;
      padding-left: 16px;
      padding-right: 16px;
      .page-left {
        width: 80px;
        margin-right: 12px;
      }
      .page-right {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        .bottom {
          margin: auto;
          .van-button {
            max-width: 480px;
          }
        }
      }
    }
	}
}
.ic-assistant {
	min-height: 100vh;
	background-color: #f9f9f9;
	.header {
		display: flex;
		align-items: flex-end;
		padding: 0.6rem 0.4rem 0.4rem;
		background-color: #fff;
		box-shadow: 0 0 8px #eee;
		.name {
			margin-left: 0.3rem;
			color: #7d7d7d;
			font-size: 0.26rem;
		}
    .logined-person {
      user-select: none;
      position: absolute;
			color: #7d7d7d;
			font-size: 0.26rem;
      right: 32px;
      cursor: pointer;
    }
	}
	.login-head {
		margin: 0.2rem 0;
		color: #999;
		font-size: 0.32rem;
		font-weight: normal;
	}
	.login-page {
    max-width: 480px;
    margin: auto;
    margin-top: 120px;
		padding: 0.5rem 0 0.1rem;
		background-color: #fff;
		box-shadow: 0 0 8px #eee;
		.login-head {
			margin: 0.3rem 0.3rem 0.6rem;
		}
		.van-password-input {
			margin: 0.4rem 0 1rem;
		}
		.van-password-input__security {
			padding: 0;
			border: 1px solid #ddd;
		}
		.van-hairline--left {
			&::after {
				border-color: #ddd;
			}
		}
	}
	.group-bar {
		padding: 0.3rem;
		margin: 0.4rem 0;
		background-color: #fff;
		box-shadow: 0 0 8px #eee;
		.group-label {
			float: left;
			margin-right: 0.2rem;
			font-size: 0.26rem;
		}
	}
	.rate-page {
		overflow: hidden;
		padding-bottom: 2rem;
		.login-head {
			margin-top: 0.5rem;
		}
		.van-card {
			margin-bottom: 0.4rem;
			padding: 0.4rem;
			background: #fff;
			box-shadow: 0 0 8px #eee;
      // height: 600px;
			.van-card__thumb {
				margin-right: 0.26rem;
			}
		}
		.van-card.not-top20 {
			padding-right: 0;
			background-color: #fcfcfc;
		}
		.van-card__title {
			font-size: 0.32rem;
		}
		.van-card__content {
			.van-tag {
				margin-right: 5px;
				min-height: 0.42rem;
				vertical-align: bottom;
				margin-right: 0.1rem;
        font-weight: 600;
			}
		}
		.van-card__desc {
			max-height: 0.4rem;
			margin-top: 0.16rem;
			margin-bottom: 0.16rem;
			font-size: 0.26rem;
			line-height: 0.4rem;
      font-weight: 600;
		}
		p {
			margin-bottom: 0.2rem;
		}
		.text {
			font-size: 0.26rem;
			text-align: left;
			padding-left: .1rem;
      margin-bottom: 3px;
		}
		.rate-box {
			margin-bottom: 0.3rem;
			padding-left: .1rem;
			text-align: left;
			.link {
				margin-right: 0.1rem;
				padding: 0.08rem 0.12rem;
				border-radius: 2px;
				border: 1px solid var(--primary-color);
				color: var(--primary-color);
			}
			.rate-label {
        display: block;
				font-size: 0.26rem;
			}
			.van-icon.van-icon-good-job {
				color: #c8c9cc;
				vertical-align: bottom;
			}
			.van-button--primary {
				.van-icon.van-icon-good-job {
					color: #fff;
				}
			}
			.van-button__text {
				margin-left: 2px;
			}
		}
    .morning {
      margin-bottom: 16px;
    }
    .rate-box {
        .resumes {
          margin: 0;
          display: inline-flex;
          height: 26.88px;
          line-height: 26.88px;
          a {
            padding: 0;
            padding-left: 6px;
            padding-right: 6px;
          }
      }
    }
    .rate-box.group-radio {
      font-weight: bold;
      margin-bottom: 26px;
      span {
        font-size: .24rem !important;
      }
    }
    .rate-box.comments {
      margin-top: 18px;
    }
		.van-rate {
			vertical-align: bottom;
		}
		.bottom {
      width: 100%;
			display: flex;
			padding: 0.3rem;
			// background-color: rgba(255, 255, 255, 0.9);
			.van-button {
        margin: auto;
			}
		}
	}
}
.text-primary {
	color: #d04a02;
}
.text-muted {
	color: #7d7d7d !important;
}
.van-cell {
	font-size: 0.26rem;
	line-height: 0.48rem;
	padding: 0.2rem 0.32rem;
}
.van-cell--large {
	padding-top: 0.24em;
	padding-bottom: 0.24rem;
	.van-cell__title {
		font-size: 0.32rem;
	}
}
.van-field__label {
	width: 1.8rem;
}
.van-button {
	height: 0.88rem;
}
.van-button--primary {
	font-size: 0.26rem;
}
.van-divider {
	margin: 0.32rem 0;
	font-size: 0.26rem;
	line-height: 0.48rem;
}
.van-card {
	font-size: 0.24rem;
}
.van-card__title {
	max-height: 0.64rem;
	line-height: 0.32rem;
}
.van-card__thumb {
	width: 1.36rem;
	height: 1.36rem;
}
.van-checkbox__icon {
	font-size: 0.4rem;
}
.van-checkbox__label {
	margin-left: 0.16rem;
	line-height: 0.4rem;
}
.van-radio__label {
	margin-left: 0.16rem;
	line-height: 0.4rem;
	line-height: 0.4rem;
}
.van-tag--medium {
	font-size: 0.24rem;
}
.van-button--mini {
	font-size: 0.2rem;
	min-width: 1rem;
	height: 0.44rem;
}
.van-radio-group {
	font-size: 0.26rem;
}
.van-notify {
	padding: 0.16rem 0.32rem;
	font-size: 0.26rem;
	line-height: 0.4rem;
}
.van-tree-select__nav {
	background-color: #fcfcfc;
  height: 100% !important;
}
.van-sidebar-item--select, .van-tree-select__content {
	background-color: #fcfcfc;
}
.van-tree-select__content {
  display: none;
}
.van-card__header {
  margin-bottom: 32px;
}
.van-card__footer {
  padding-right: 12px;
}
.van-card:not(:first-child) {
    margin-top: 0;
}
.van-tag {
  color: #000 !important;
}
.van-empty {
  margin: auto;
}
.page-right {
  .van-field {
    border: 1px solid #eee;
  }
}
</style>
